import { FlightProblems, FlightStatus } from "@/core/types/types";

const flightStatusToFlightProblemMatrix: Record<
  FlightStatus,
  FlightProblems | null
> = {
  [FlightStatus.Unknown]: null,
  [FlightStatus.Delayed]: FlightProblems.Delayed,
  [FlightStatus.Cancelled]: FlightProblems.Cancelled,
  [FlightStatus.OnTime]: FlightProblems.OnTime,
};

const getProblemByFlightStatus = (
  flightStatus: FlightStatus
): FlightProblems | null => {
  const problemIsFound: boolean =
    flightStatus in flightStatusToFlightProblemMatrix;
  if (!flightStatus || !problemIsFound) {
    return null;
  }

  return flightStatusToFlightProblemMatrix[flightStatus];
};

export default getProblemByFlightStatus;
